import axios from 'axios';

const getBaseURL = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001/api';
  }
  return 'https://factutracks.com/api';
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  timeout: 30000,
});

// Envía el error al backend de forma silenciosa (sin axios para evitar bucles)
const logErrorToServer = (error) => {
  try {
    const token = sessionStorage.getItem('token');
    if (!token) return; // Sin sesión no hay tenant, no loguear

    const status  = error.response?.status;
    const mensaje = error.response?.data?.message || error.response?.data?.error || error.message;

    // No loguear 401 ni 403 por suscripción suspendida — son comportamiento esperado
    if (status === 401) return;
    if (status === 403 && mensaje?.includes('suspendido')) return;

    fetch(`${getBaseURL()}/error-logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        nivel:      'error',
        origen:     'frontend',
        mensaje:    mensaje || 'Error desconocido',
        endpoint:   error.config?.url  || null,
        metodo:     error.config?.method?.toUpperCase() || null,
        codigo_http: status || null,
        datos_extra: error.response?.data || null
      })
    }).catch(() => {}); // Silencioso si el fetch también falla
  } catch {
    // Nunca propagar errores del logger
  }
};

// Interceptor request — agrega token
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor response — manejo de errores silencioso
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status  = error.response?.status;
    const mensaje = error.response?.data?.message || '';

    // Redirigir si el token expiró o la sesión fue desplazada (401 fuera del login)
    if (status === 401) {
      const token = sessionStorage.getItem('token');
      if (token && !error.config?.url?.includes('/auth/login')) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        const errorCode = error.response?.data?.error;
        if (errorCode === 'SESSION_DISPLACED') {
          window.location.href = '/agenda/login?session=displaced';
        } else {
          window.location.href = '/agenda/login';
        }
      }
    }

    // 403 por suscripción suspendida: silencioso, lo maneja cada página
    if (status === 403 && mensaje.includes('suspendido')) {
      return Promise.reject(error);
    }

    // Timeout
    if (error.code === 'ECONNABORTED') {
      logErrorToServer(error);
      return Promise.reject(error);
    }

    // Cualquier otro error: loguear en BD y NO mostrar en consola
    logErrorToServer(error);

    return Promise.reject(error);
  }
);

export default api;
